import { Component, OnInit } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { Data2Service } from 'src/app/common/data2.service';
import { LoaderService } from 'src/app/common/loader/loader.service';

@Component({
	selector: 'app-resident-document',
	templateUrl: './resident-document.component.html',
	styleUrls: ['./resident-document.component.css'],
})
export class ResidentDocumentComponent implements OnInit {
	private itemsBeforeDataLoad = 1;
	reservationId = '';
	documentType = '';
	data = null;
	btnLabel = 'Anuluj rezewację';
	users: Array<any> = [];
	createdBy;
	filters;

	constructor(
		private readonly api: Data2Service,
		private readonly loader: LoaderService,
		private readonly route: ActivatedRoute,
	) {}

	ngOnInit(): void {
		this.api.get('/users/', (result, error) => {
			this.users = result.data;
			this.loadData();
		});
	}

	print() {
		window.print();
	}

	private loadData() {
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.documentType = this.route.snapshot.params['type'];
		const parms = this.route.snapshot.params['id'];
		this.api.get('/resident/residentTripsReservation/' + parms, (result, error) => {
			this.data = result.data;
			this.convertElements(this.users, this.data.createdBy);
		});
	}

	cancel(data) {
		data.status = !data.status;
		this.btnLabel = 'Anulowano';
		this.api.command('/resident/residentTripsReservation/' + data.id + '/', data, (result, error) => {
			if (error) {
				data.status = !data.status;
				return;
			}
		});
	}

	private convertElements(objects: Array<any>, element: Array<any>) {
		if (this.data.status) {
			this.btnLabel = 'Anulowano';
		}
		this.createdBy = objects.find((obj) => obj.id == element);
	}
}
